/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanExpenseRequest
 */
export interface CreatePlanExpenseRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanExpenseRequest
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanExpenseRequest
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanExpenseRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePlanExpenseRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanExpenseRequest
     */
    currency?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePlanExpenseRequest
     */
    expenseDate: Date;
}

/**
 * Check if a given object implements the CreatePlanExpenseRequest interface.
 */
export function instanceOfCreatePlanExpenseRequest(value: object): value is CreatePlanExpenseRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('expenseDate' in value) || value['expenseDate'] === undefined) return false;
    return true;
}

export function CreatePlanExpenseRequestFromJSON(json: any): CreatePlanExpenseRequest {
    return CreatePlanExpenseRequestFromJSONTyped(json, false);
}

export function CreatePlanExpenseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanExpenseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'category': json['category'] == null ? undefined : json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'expenseDate': (new Date(json['expenseDate'])),
    };
}

export function CreatePlanExpenseRequestToJSON(json: any): CreatePlanExpenseRequest {
    return CreatePlanExpenseRequestToJSONTyped(json, false);
}

export function CreatePlanExpenseRequestToJSONTyped(value?: CreatePlanExpenseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'category': value['category'],
        'description': value['description'],
        'amount': value['amount'],
        'currency': value['currency'],
        'expenseDate': ((value['expenseDate']).toISOString().substring(0,10)),
    };
}

